import axios from 'axios';
import type { QueuePreferences } from 'Router/pages/AnsweringPages/AnsweringQueue/types';

const deleteQueuePreferences = async (): Promise<QueuePreferences> => {
  const { data } = await axios.post<QueuePreferences>(
    '/answering/delete_queue_preferences',
  );
  return data;
};

export default deleteQueuePreferences;
